import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Animated from 'react-native-reanimated';

export const CarouselWrapper = styled.View`
  margin: ${RFValue(0)}px 0px;
`;

export const DotsRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${RFValue(10)}px;
  gap: ${RFValue(5)}px;
`;

export const Dot = styled.View<{active: boolean}>`
  height: ${RFValue(6)}px;
  width: ${({active}) => (active ? RFValue(18) : RFValue(6))}px;
  border-radius: ${RFValue(3)}px;
  background-color: ${({theme}) => theme.colors.carousel_dot_inactive};
  overflow: hidden;
`;

export const DotFill = styled(Animated.View)`
  height: 100%;
  border-radius: ${RFValue(3)}px;
  background-color: ${({theme}) => theme.colors.carousel_dot_active};
`;

export const DotBtn = styled.TouchableOpacity``;
